import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["leftWingRows", "rightWingRows", "middleSectionRows", "shortChairRowsLeftInner", "omitMiddleFrontRow"]

  connect() {
    console.log("Chair arrangement controller connected")
    this.element.addEventListener('input', this.handleFieldChange.bind(this))
  }

  handleFieldChange(event) {
    const target = event.target
    if (target.hasAttribute('data-chair-arrangement-target')) {
      console.log(`Field changed: ${target.name} = ${target.value}`)
      this.updatePreview()
    }
  }

  async updatePreview() {
    const formData = new FormData(this.element)
    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    
    try {
      const response = await fetch('/chair_arrangements/preview', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': token
        }
      })
      
      if (response.ok) {
        const turboStream = await response.text()
        Turbo.renderStreamMessage(turboStream)
      }
    } catch (error) {
      console.log('Preview update failed:', error)
    }
  }
}